"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadBasisEncoderModule = loadBasisEncoderModule;
exports.loadBasisTrascoderModule = loadBasisTrascoderModule;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _workerUtils = require("@loaders.gl/worker-utils");
var VERSION = typeof "3.3.2" !== 'undefined' ? "3.3.2" : 'beta';

var BASIS_CDN_ENCODER_WASM = "https://unpkg.com/@loaders.gl/textures@".concat(VERSION, "/dist/libs/basis_encoder.wasm");
var BASIS_CDN_ENCODER_JS = "https://unpkg.com/@loaders.gl/textures@".concat(VERSION, "/dist/libs/basis_encoder.js");
var loadBasisTranscoderPromise;

function loadBasisTrascoderModule(_x) {
  return _loadBasisTrascoderModule.apply(this, arguments);
}
function _loadBasisTrascoderModule() {
  _loadBasisTrascoderModule = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(options) {
    var modules;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            modules = options.modules || {};
            if (!modules.basis) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", modules.basis);
          case 3:
            loadBasisTranscoderPromise = loadBasisTranscoderPromise || loadBasisTrascoder(options);
            _context.next = 6;
            return loadBasisTranscoderPromise;
          case 6:
            return _context.abrupt("return", _context.sent);
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadBasisTrascoderModule.apply(this, arguments);
}
function loadBasisTrascoder(_x2) {
  return _loadBasisTrascoder.apply(this, arguments);
}
function _loadBasisTrascoder() {
  _loadBasisTrascoder = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(options) {
    var BASIS, wasmBinary, _yield$Promise$all, _yield$Promise$all2;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            BASIS = null;
            wasmBinary = null;
            _context2.t0 = Promise;
            _context2.next = 5;
            return (0, _workerUtils.loadLibrary)('basis_transcoder.js', 'textures', options);
          case 5:
            _context2.t1 = _context2.sent;
            _context2.next = 8;
            return (0, _workerUtils.loadLibrary)('basis_transcoder.wasm', 'textures', options);
          case 8:
            _context2.t2 = _context2.sent;
            _context2.t3 = [_context2.t1, _context2.t2];
            _context2.next = 12;
            return _context2.t0.all.call(_context2.t0, _context2.t3);
          case 12:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
            BASIS = _yield$Promise$all2[0];
            wasmBinary = _yield$Promise$all2[1];
            BASIS = BASIS || globalThis.BASIS;
            _context2.next = 19;
            return initializeBasisTrascoderModule(BASIS, wasmBinary);
          case 19:
            return _context2.abrupt("return", _context2.sent);
          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadBasisTrascoder.apply(this, arguments);
}
function initializeBasisTrascoderModule(BasisModule, wasmBinary) {
  var options = {};
  if (wasmBinary) {
    options.wasmBinary = wasmBinary;
  }
  return new Promise(function (resolve) {
    BasisModule(options).then(function (module) {
      var BasisFile = module.BasisFile,
        initializeBasis = module.initializeBasis;
      initializeBasis();
      resolve({
        BasisFile: BasisFile
      });
    });
  });
}
var loadBasisEncoderPromise;

function loadBasisEncoderModule(_x3) {
  return _loadBasisEncoderModule.apply(this, arguments);
}
function _loadBasisEncoderModule() {
  _loadBasisEncoderModule = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(options) {
    var modules;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            modules = options.modules || {};
            if (!modules.basisEncoder) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", modules.basisEncoder);
          case 3:
            loadBasisEncoderPromise = loadBasisEncoderPromise || loadBasisEncoder(options);
            _context3.next = 6;
            return loadBasisEncoderPromise;
          case 6:
            return _context3.abrupt("return", _context3.sent);
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _loadBasisEncoderModule.apply(this, arguments);
}
function loadBasisEncoder(_x4) {
  return _loadBasisEncoder.apply(this, arguments);
}
function _loadBasisEncoder() {
  _loadBasisEncoder = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4(options) {
    var BASIS_ENCODER, wasmBinary, _yield$Promise$all3, _yield$Promise$all4;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            BASIS_ENCODER = null;
            wasmBinary = null;
            _context4.t0 = Promise;
            _context4.next = 5;
            return (0, _workerUtils.loadLibrary)(BASIS_CDN_ENCODER_JS, 'textures', options);
          case 5:
            _context4.t1 = _context4.sent;
            _context4.next = 8;
            return (0, _workerUtils.loadLibrary)(BASIS_CDN_ENCODER_WASM, 'textures', options);
          case 8:
            _context4.t2 = _context4.sent;
            _context4.t3 = [_context4.t1, _context4.t2];
            _context4.next = 12;
            return _context4.t0.all.call(_context4.t0, _context4.t3);
          case 12:
            _yield$Promise$all3 = _context4.sent;
            _yield$Promise$all4 = (0, _slicedToArray2.default)(_yield$Promise$all3, 2);
            BASIS_ENCODER = _yield$Promise$all4[0];
            wasmBinary = _yield$Promise$all4[1];
            BASIS_ENCODER = BASIS_ENCODER || globalThis.BASIS;
            _context4.next = 19;
            return initializeBasisEncoderModule(BASIS_ENCODER, wasmBinary);
          case 19:
            return _context4.abrupt("return", _context4.sent);
          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _loadBasisEncoder.apply(this, arguments);
}
function initializeBasisEncoderModule(BasisEncoderModule, wasmBinary) {
  var options = {};
  if (wasmBinary) {
    options.wasmBinary = wasmBinary;
  }
  return new Promise(function (resolve) {
    BasisEncoderModule(options).then(function (module) {
      var BasisFile = module.BasisFile,
        KTX2File = module.KTX2File,
        initializeBasis = module.initializeBasis,
        BasisEncoder = module.BasisEncoder;
      initializeBasis();
      resolve({
        BasisFile: BasisFile,
        KTX2File: KTX2File,
        BasisEncoder: BasisEncoder
      });
    });
  });
}
//# sourceMappingURL=basis-module-loader.js.map